import { StyleSheet, View } from 'react-native';

import { MenuAcceleratorBadgeSvg } from './menu-accelerator-badge';

export const MenuAcceleratorBadge = () => {
  return (
    <View style={styles.container}>
      <MenuAcceleratorBadgeSvg />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 9999,
    height: 24,
    width: 24,
  },
});
